import { Component, inject, OnInit } from '@angular/core';
import { FitupService } from '../../../shared/service/fitup/fitup.service';
import { ThinkModelComponent } from '../../../shared/model/fitup/generic.model';
import { ResponsiveService } from '../../../shared/service/fitup/responsive.service';

@Component({
  selector: 'app-modern-nav',
  templateUrl: './modern-nav.component.html',
  styleUrls: ['./modern-nav.component.scss']
})
export class ModernNavComponent implements OnInit {
  private readonly _fitUpSvc = inject(FitupService)
  private readonly _responsiveSvc = inject(ResponsiveService)
  public screenSize$ = this._responsiveSvc.screenSize$
  appModernNav?: ThinkModelComponent;
  logoText?: string;

  constructor() { }

  ngOnInit(): void {
    this.getDados()
  }

  getDados(): void {
    this._fitUpSvc.getStrapiDataObservable().subscribe(updateData => {
      this.appModernNav = updateData
      this.logoText = this._fitUpSvc.getComponentData('app_modern_nav').data.attributes.logoText
    })
  }
}
